import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Group } from '../classes/index';

@Injectable()
export class GroupService {

	constructor(
		private firestore: Firestore
	) { }

	listTeamGroups(gameId){
		return collectionData(collection(this.firestore, `games/${gameId}/groups`), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new Group();
				object.fromJSON(data);
				return object;
			});
		}));
	}

	getGroup(gameId, groupId){
		return docData(doc(this.firestore, `games/${gameId}/groups/${groupId}`), {idField: 'id'})
		.pipe(map(group => {
			if(group){
				let object = new Group();
				object.fromJSON(group);
				return object;
			}
			return null;
		}));
	}

	addGroup(gameId, data) {
		return addDoc(collection(this.firestore, `games/${gameId}/groups`), {...data});
	}

	updateGroup(gameId, groupId, data){
		return updateDoc(doc(this.firestore, `games/${gameId}/groups/${groupId}`), data);
	}

	async sendMessage(gameId, groupId, conversationId, chatMessage, teamId){
		await addDoc(collection(this.firestore, `games/${gameId}/groups/${groupId}/chats/${conversationId}/messages`), {...chatMessage});
		let conversationData = {
			members: ['admin', teamId],
			lastMessage: chatMessage.text,
			lastMessageFrom: chatMessage.from,
			lastMessageTime: chatMessage.time,
		};
		await setDoc(doc(this.firestore, `games/${gameId}/groups/${groupId}/chats/${conversationId}`), conversationData, {merge:true});
	}

	deleteGroup(gameId, groupUid) {
		return deleteDoc(doc(this.firestore, `games/${gameId}/groups/${groupUid}`));
	}
}
